import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Phone, MessageCircle, ArrowUp } from "lucide-react";
import { FLOAT } from "@/constants/testIds";
import { telHref, whatsappHref } from "@/data/site";
import { scrollToTop } from "@/lib/scroll";

export const FloatingButtons = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 500);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="fixed bottom-5 right-5 z-40 flex flex-col items-end gap-3">
      <AnimatePresence>
        {show && (
          <motion.button
            data-testid={FLOAT.top}
            onClick={scrollToTop}
            initial={{ opacity: 0, scale: 0.6 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.6 }}
            className="grid place-items-center h-12 w-12 rounded-full bg-white text-brand-blue shadow-[0_10px_30px_rgb(0,0,0,0.12)] border border-slate-200 transition-transform hover:-translate-y-0.5"
            aria-label="Back to top"
          >
            <ArrowUp className="h-5 w-5" />
          </motion.button>
        )}
      </AnimatePresence>

      <a
        data-testid={FLOAT.call}
        href={telHref}
        className="grid place-items-center h-14 w-14 rounded-full bg-brand-blue text-white shadow-[0_12px_30px_rgb(0,75,135,0.35)] transition-transform hover:-translate-y-0.5 active:scale-95"
        aria-label="Call now"
      >
        <Phone className="h-6 w-6" />
      </a>

      <a
        data-testid={FLOAT.whatsapp}
        href={whatsappHref}
        target="_blank"
        rel="noopener noreferrer"
        className="relative grid place-items-center h-14 w-14 rounded-full bg-brand-green text-white shadow-[0_12px_30px_rgb(16,185,129,0.4)] transition-transform hover:-translate-y-0.5 active:scale-95"
        aria-label="WhatsApp"
      >
        <span className="absolute inset-0 rounded-full bg-brand-green animate-ping opacity-30" />
        <MessageCircle className="relative h-6 w-6" />
      </a>
    </div>
  );
};
